import React from 'react';

interface TableSurfaceProps {
  children: React.ReactNode;
  outerClassName?: string;
  contentClassName?: string;
  minHeight?: string;
  includeTexture?: boolean;
}

export const TableSurface: React.FC<TableSurfaceProps> = ({
  children,
  outerClassName = '',
  contentClassName = '',
  minHeight,
  includeTexture = true
}) => {
  return (
    <div
      className={`relative rounded-2xl overflow-hidden shadow-2xl ${outerClassName}`}
      style={minHeight ? { minHeight } : undefined}
    >
      {/* Table border - wood frame effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-800 via-amber-900 to-amber-950 p-2 sm:p-3 pointer-events-none">
        <div className="w-full h-full rounded-xl bg-gradient-to-br from-green-700 via-green-800 to-green-900" />
      </div>

      {/* Table felt */}
      <div className={`relative m-2 sm:m-3 rounded-xl bg-gradient-to-br from-green-700 via-green-800 to-green-900 p-4 sm:p-6 md:p-8 ${contentClassName}`}>
        {/* Felt texture */}
        {includeTexture && (
          <div
            className="absolute inset-0 opacity-30 rounded-xl pointer-events-none"
            style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,0,0,0.15) 1px, transparent 0)', backgroundSize: '6px 6px' }}
          />
        )}
        {children}
      </div>
    </div>
  );
};

